import React, { useEffect } from 'react';
import {
  Button,
  Col,
  Panel,
  FlexboxGrid,
  Form,
  Input,
  InputNumber,
  InputPicker,
  IconButton
} from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';
const PackageLoadability = ({
  data5,
  setData5,
  //data of Inputes
  cartontype,
  siii,
  //Value of the InputeNumber
  totalcbm1,
  totalcft,
  feet20,
  feet40,
  feet20hc,
  //Function to handle inputes
  handleInputChange,
  label,
  addPackaging,
  setTotalCbm,
  setTotalCFT,
  setFeet20,
  setFeet40,
  setFeet20hc
}) => {

  const recalculateTotals = packagingData => {
    let totalcbm = 0;
    packagingData.forEach(packaging => {
      const { Carton_Length, Carton_Width, Carton_Thick, Carton_Unit, Carton_PCS, CartonType } =
        packaging;
      let productcbm1 = 0;

      if (Carton_Unit === 'cm') {
        productcbm1 = (Carton_Length * Carton_Width * Carton_Thick) / 1000000 / Carton_PCS;
      } else {
        productcbm1 = (Carton_Length * Carton_Width * Carton_Thick) / 61023 / Carton_PCS;
      }

      if (CartonType === 'master') {
        totalcbm += productcbm1;
      }
    });

    setTotalCbm(totalcbm ? totalcbm.toFixed(4) : 0);
    const totalCFT = totalcbm * 35.3147;
    setTotalCFT(totalCFT.toFixed(4));
    setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
    setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
    setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);
  };

  const deletePackege = index => {
    setData5(prevData => {
      const updatedPackaging = [...prevData.Packaging];
      updatedPackaging.splice(index, 1);

      const updatedData = {
        ...prevData,
        Packaging: updatedPackaging
      };

      // Call the recalculation function after updating data
      recalculateTotals(updatedPackaging);

      return updatedData;
    });
  };

  const handleInputChange1 = (inputName, event, index) => {
    let value = event?.target?.value ?? event; // Null check

    setData5(prevData => {
      const updatedPackaging = [...prevData.Packaging];
      if (inputName.startsWith('CartonType')) {
        updatedPackaging[index].CartonType = value;
      } else if (inputName.startsWith('Carton_Unit')) {
        updatedPackaging[index].Carton_Unit = value;
      } else if (inputName.startsWith('Carton_Length')) {
        updatedPackaging[index].Carton_Length = value;
      } else if (inputName.startsWith('Carton_Width')) {
        updatedPackaging[index].Carton_Width = value;
      } else if (inputName.startsWith('Carton_Thick')) {
        updatedPackaging[index].Carton_Thick = value;
      } else if (inputName.startsWith('Carton_PCS')) {
        updatedPackaging[index].Carton_PCS = value;
      } else if (inputName.startsWith('Carton_GrsWt')) {
        updatedPackaging[index].Carton_GrsWt = value;
      }

      return { ...prevData, Packaging: updatedPackaging };
    });
  };
  // Recalculate CBM when data5 updates
  useEffect(() => {
    let totalcbm = 0;
    let updatedPackaging = [...data5.Packaging];

    updatedPackaging.forEach((pkg, i) => {
      const { Carton_Length, Carton_Width, Carton_Thick, Carton_Unit, Carton_PCS, CartonType } = pkg;

      // Calculate product CBM
      let productcbm = (Carton_Length * Carton_Width * Carton_Thick) / (Carton_Unit === 'cm' ? 1000000 : 61023);

      // CBM per piece
      let cbmPerPc = Carton_PCS === 0 ? productcbm : productcbm / Carton_PCS;

      // Only add master carton CBM to total
      if (CartonType === 'master') totalcbm += cbmPerPc;

      // ✅ Store values with 3 decimals
      updatedPackaging[i].Carton_CBMperpc = parseFloat(cbmPerPc.toFixed(3));
      updatedPackaging[i].Carton_CBM = parseFloat(productcbm.toFixed(3));
    });

    // ✅ Update totals with 3 decimals as well
    setTotalCbm(totalcbm.toFixed(3));
    setTotalCFT((totalcbm * 35.3147).toFixed(3));
    setFeet20(totalcbm ? Math.floor(27 / totalcbm) : 0);
    setFeet40(totalcbm ? Math.floor(56 / totalcbm) : 0);
    setFeet20hc(totalcbm ? Math.floor(65 / totalcbm) : 0);

    setData5(prev => ({ ...prev, Packaging: updatedPackaging }));
  }, [data5]);


  return (
    <>
      <Panel header="Packaging">
        <div>
          <Form fluid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item as={Col} colspan={24} md={22}>
                {data5.Packaging.map((packaging, index) => (
                  <div key={index}>
                    <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
                      <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                        <Form.ControlLabel>Carton Type</Form.ControlLabel>
                        <InputPicker
                          data={cartontype}
                          name={`CartonType_${index}`}
                          value={packaging.CartonType}
                          cleanable={false}
                          onChange={event =>
                            handleInputChange1(`CartonType_${index}`, event, index)
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                        <Form.ControlLabel>SizeUnit</Form.ControlLabel>
                        <InputPicker
                          data={siii}
                          name={`Carton_Unit_${index}`}
                          value={packaging.Carton_Unit || 'inch'}
                          cleanable={false}
                          onChange={event =>
                            handleInputChange1(`Carton_Unit_${index}`, event, index)
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>{label[0]?.attributes?.length}</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          name={`Carton_Length_${index}`}
                          value={packaging.Carton_Length ? packaging.Carton_Length : 0}
                          onChange={event =>
                            handleInputChange1(`Carton_Length_${index}`, event, index)
                          }
                        // min={0}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>{label[0]?.attributes?.width}</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          name={`Carton_Width_${index}`}
                          value={packaging.Carton_Width ? packaging.Carton_Width : 0}
                          onChange={event =>
                            handleInputChange1(`Carton_Width_${index}`, event, index)
                          }
                          min={0}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>{label[0]?.attributes?.height}</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          name={`Carton_Thick_${index}`}
                          value={packaging.Carton_Thick ? packaging.Carton_Thick : 0}
                          onChange={event =>
                            handleInputChange1(`Carton_Thick_${index}`, event, index)
                          }
                          min={0}
                        />
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>Box Area</Form.ControlLabel>
                        <Input
                          readOnly
                          name={`Perpc_${index}`}
                          value={packaging.Carton_CBMperpc}
                          onChange={event => handleInputChange1(`Perpc_${index}`, event, index)}
                        />
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>PCS</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          min={1}
                          name={`Carton_PCS_${index}`}
                          value={packaging.Carton_PCS ? packaging.Carton_PCS : 1}
                          onChange={event =>
                            handleInputChange1(`Carton_PCS_${index}`, event, index)
                          }
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>{label[0]?.attributes?.cbm}</Form.ControlLabel>
                        <Input
                          readOnly
                          name={`Carton_CBM_${index}`}
                          value={packaging.Carton_CBM}
                          onChange={event =>
                            handleInputChange1(`Carton_CBM_${index}`, event, index)
                          }
                        />
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                        <Form.ControlLabel>{label[0]?.attributes?.GrossWgt}</Form.ControlLabel>
                        <InputNumber
                          step={null}
                          name={`Carton_GrsWt_${index}`}
                          value={packaging.Carton_GrsWt ? packaging.Carton_GrsWt : 0}
                          onChange={event =>
                            handleInputChange1(`Carton_GrsWt_${index}`, event, index)
                          }
                          min={0}
                        />
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item as={Col} colspan={24} md={1}>
                        {index > 0 && (
                          <IconButton
                            active
                            style={{ marginTop: '20px' }}
                            onClick={() => deletePackege(index)}
                            icon={<TrashIcon />}
                          />
                        )}
                      </FlexboxGrid.Item>
                    </FlexboxGrid>
                  </div>
                ))}
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                <Button active onClick={addPackaging} style={{ marginTop: '20px' }}>
                  Add Row
                </Button>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Form>
        </div>
      </Panel>

      <Panel header="Loadability">
        <Form fluid>
          <FlexboxGrid justify="space-between">
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Total CBM</Form.ControlLabel>
                <InputNumber
                  id="Total_CBM"
                  name="Total_CBM"
                  value={totalcbm1}
                  onChange={value => handleInputChange('Total_CBM', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Total CFT</Form.ControlLabel>
                <InputNumber
                  id="Total_CFT"
                  name="Total_CFT"
                  value={totalcft}
                  onChange={value => handleInputChange('Total_CFT', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>20FT</Form.ControlLabel>
                <Input
                  id="TwentyFT"
                  name="TwentyFT"
                  value={feet20}
                  onChange={value => handleInputChange('TwentyFT', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>40FT</Form.ControlLabel>
                <Input
                  id="FortyFT"
                  name="FortyFT"
                  value={feet40}
                  onChange={value => handleInputChange('FortyFT', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={4}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>40HQ</Form.ControlLabel>
                <Input
                  id="FortyHQ"
                  name="FortyHQ"
                  value={feet20hc}
                  onChange={value => handleInputChange('FortyHQ', value, 0)}
                  readOnly
                />
              </Form.Group>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Form>
      </Panel>
    </>
  );
};

export default PackageLoadability;
